import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 身分證件上傳
 */
const IdDocUpload = [
    'POST',
    RouteUrlList.API_IdDocUpload.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: '',

        idCheck_P: '',
        idCheck_T: '',
        idCheck_Y: '',
        idCheck_M: '',
        idCheck_D: ''
    }
];
export default IdDocUpload;
